import React, { useContext } from 'react';
import { TextWritingType, type ILayerProps, type ITextLayerProps } from '@/version-types';
import { useTexture } from '../../hooks';
import { getTextureUrl } from '../../utils';
import { TextLayerContext } from '../context';

type Props = {
    layer: ILayerProps;
};

export const TextureDef: React.FC<Props> = ({ layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { id, width: layerWidth, height: layerHeight } = layer;
    const layerData = layer.data as ITextLayerProps;
    const { texture, writingMode } = layerData;
    const isVertical = writingMode !== TextWritingType.HORIZONTAL_TB;

    const { textureConfig } = useTexture(texture);

    // ATTENTION: 由于竖排文字时，纹理填充是通过 clipPath 的方式去 hack
    // 所以当竖排文字时，不需要在定义纹理的 def

    if (!texture || !texture.url || isVertical) return null;

    const { stretch } = texture;
    const url = getTextureUrl(texture.url);
    const patternWidth = stretch === 'repeat' ? textureConfig?.width || layerWidth : layerWidth;
    const patternHeight = stretch === 'repeat' ? textureConfig?.height || layerHeight : layerHeight;
    const preserveAspectRatio = stretch === 'repeat' ? 'none' : 'xMidYMid slice';

    return (
        <pattern
            id={`texture-${id}-${defIDSuffix}`}
            patternUnits="userSpaceOnUse"
            width={patternWidth}
            height={patternHeight}
        >
            <image
                id={`texture-image-${id}`}
                href={url}
                width={patternWidth}
                height={patternHeight}
                preserveAspectRatio={preserveAspectRatio}
            />
        </pattern>
    );
};
